import { noop } from 'lodash';
import { TradingProvider } from '../type';

export const useEconiaTrading = (): TradingProvider => {
  return {
    markets: [],
    currentMarket: undefined,
    currentMarketId: undefined,
    changeMarket: noop,
    refreshCurrentMarket: () => Promise.resolve(),
    totalOrders: [],
    accountLoading: false,
    setInitialTradingPair: noop,
    refreshUserAccount: () => Promise.resolve(),
    tradingTokens: [],
    marketLoading: true,
    marketEmpty: true,
    setEnableTradingRefresh: noop,
  };
};
